import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PackingCategoryDto } from './packing-category-dto';


export class AllPackingCategoryResponseModel extends GlobalResponseObject {
    data?: PackingCategoryDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PackingCategoryDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

